var Xt = Object.create;
var ue = Object.defineProperty,
  $t = Object.defineProperties,
  eo = Object.getOwnPropertyDescriptor,
  to = Object.getOwnPropertyDescriptors,
  oo = Object.getOwnPropertyNames,
  Be = Object.getOwnPropertySymbols,
  ro = Object.getPrototypeOf,
  Ue = Object.prototype.hasOwnProperty,
  no = Object.prototype.propertyIsEnumerable;
var Ge = (t, e, o) =>
    e in t
      ? ue(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o })
      : (t[e] = o),
  v = (t, e) => {
    for (var o in e || (e = {})) Ue.call(e, o) && Ge(t, o, e[o]);
    if (Be) for (var o of Be(e)) no.call(e, o) && Ge(t, o, e[o]);
    return t;
  },
  E = (t, e) => $t(t, to(e));
var A = (t, e) => () => (e || t((e = { exports: {} }).exports, e), e.exports);
var io = (t, e, o, r) => {
  if ((e && typeof e == 'object') || typeof e == 'function')
    for (let i of oo(e))
      !Ue.call(t, i) &&
        i !== o &&
        ue(t, i, {
          get: () => e[i],
          enumerable: !(r = eo(e, i)) || r.enumerable,
        });
  return t;
};
var j = (t, e, o) => (
  (o = t != null ? Xt(ro(t)) : {}),
  io(
    e || !t || !t.__esModule
      ? ue(o, 'default', { value: t, enumerable: !0 })
      : o,
    t,
  )
);
var fe = A((je, qe) => {
  (function (t) {
    var e;
    if (
      (typeof define == 'function' && define.amd && (define(t), (e = !0)),
      typeof je == 'object' && ((qe.exports = t()), (e = !0)),
      !e)
    ) {
      var o = window.Cookies,
        r = (window.Cookies = t());
      r.noConflict = function () {
        return (window.Cookies = o), r;
      };
    }
  })(function () {
    function t() {
      for (var r = 0, i = {}; r < arguments.length; r++) {
        var n = arguments[r];
        for (var s in n) i[s] = n[s];
      }
      return i;
    }
    function e(r) {
      return r.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function o(r) {
      function i() {}
      function n(d, l, a) {
        if (typeof document != 'undefined') {
          (a = t({ path: '/' }, i.defaults, a)),
            typeof a.expires == 'number' &&
              (a.expires = new Date(new Date() * 1 + a.expires * 864e5)),
            (a.expires = a.expires ? a.expires.toUTCString() : '');
          try {
            var u = JSON.stringify(l);
            /^[\{\[]/.test(u) && (l = u);
          } catch (x) {}
          (l = r.write
            ? r.write(l, d)
            : encodeURIComponent(String(l)).replace(
                /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                decodeURIComponent,
              )),
            (d = encodeURIComponent(String(d))
              .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
              .replace(/[\(\)]/g, escape));
          var f = '';
          for (var p in a)
            a[p] &&
              ((f += '; ' + p), a[p] !== !0 && (f += '=' + a[p].split(';')[0]));
          return (document.cookie = d + '=' + l + f);
        }
      }
      function s(d, l) {
        if (typeof document != 'undefined') {
          for (
            var a = {},
              u = document.cookie ? document.cookie.split('; ') : [],
              f = 0;
            f < u.length;
            f++
          ) {
            var p = u[f].split('='),
              x = p.slice(1).join('=');
            !l && x.charAt(0) === '"' && (x = x.slice(1, -1));
            try {
              var y = e(p[0]);
              if (((x = (r.read || r)(x, y) || e(x)), l))
                try {
                  x = JSON.parse(x);
                } catch (g) {}
              if (((a[y] = x), d === y)) break;
            } catch (g) {}
          }
          return d ? a[d] : a;
        }
      }
      return (
        (i.set = n),
        (i.get = function (d) {
          return s(d, !1);
        }),
        (i.getJSON = function (d) {
          return s(d, !0);
        }),
        (i.remove = function (d, l) {
          n(d, '', t(l, { expires: -1 }));
        }),
        (i.defaults = {}),
        (i.withConverter = o),
        i
      );
    }
    return o(function () {});
  });
});
var We = A((L) => {
  L.parse = function (t) {
    var e = document.createElement('a');
    return (
      (e.href = t),
      {
        href: e.href,
        host: e.host || location.host,
        port: e.port === '0' || e.port === '' ? so(e.protocol) : e.port,
        hash: e.hash,
        hostname: e.hostname || location.hostname,
        pathname: e.pathname.charAt(0) != '/' ? '/' + e.pathname : e.pathname,
        protocol:
          !e.protocol || e.protocol == ':' ? location.protocol : e.protocol,
        search: e.search,
        query: e.search.slice(1),
      }
    );
  };
  L.isAbsolute = function (t) {
    return t.indexOf('//') == 0 || !!~t.indexOf('://');
  };
  L.isRelative = function (t) {
    return !L.isAbsolute(t);
  };
  L.isCrossDomain = function (t) {
    t = L.parse(t);
    var e = L.parse(window.location.href);
    return (
      t.hostname !== e.hostname ||
      t.port !== e.port ||
      t.protocol !== e.protocol
    );
  };
  function so(t) {
    switch (t) {
      case 'http:':
        return 80;
      case 'https:':
        return 443;
      default:
        return location.port;
    }
  }
});
var Ve = A((Cr, Ke) => {
  var q = 1e3,
    W = q * 60,
    K = W * 60,
    V = K * 24,
    ao = V * 365.25;
  Ke.exports = function (t, e) {
    e = e || {};
    var o = typeof t;
    if (o === 'string' && t.length > 0) return lo(t);
    if (o === 'number' && isNaN(t) === !1) return e.long ? fo(t) : uo(t);
    throw new Error(
      'val is not a non-empty string or a valid number. val=' +
        JSON.stringify(t),
    );
  };
  function lo(t) {
    if (((t = String(t)), !(t.length > 100))) {
      var e =
        /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
          t,
        );
      if (e) {
        var o = parseFloat(e[1]),
          r = (e[2] || 'ms').toLowerCase();
        switch (r) {
          case 'years':
          case 'year':
          case 'yrs':
          case 'yr':
          case 'y':
            return o * ao;
          case 'days':
          case 'day':
          case 'd':
            return o * V;
          case 'hours':
          case 'hour':
          case 'hrs':
          case 'hr':
          case 'h':
            return o * K;
          case 'minutes':
          case 'minute':
          case 'mins':
          case 'min':
          case 'm':
            return o * W;
          case 'seconds':
          case 'second':
          case 'secs':
          case 'sec':
          case 's':
            return o * q;
          case 'milliseconds':
          case 'millisecond':
          case 'msecs':
          case 'msec':
          case 'ms':
            return o;
          default:
            return;
        }
      }
    }
  }
  function uo(t) {
    return t >= V
      ? Math.round(t / V) + 'd'
      : t >= K
        ? Math.round(t / K) + 'h'
        : t >= W
          ? Math.round(t / W) + 'm'
          : t >= q
            ? Math.round(t / q) + 's'
            : t + 'ms';
  }
  function fo(t) {
    return (
      Y(t, V, 'day') ||
      Y(t, K, 'hour') ||
      Y(t, W, 'minute') ||
      Y(t, q, 'second') ||
      t + ' ms'
    );
  }
  function Y(t, e, o) {
    if (!(t < e))
      return t < e * 1.5
        ? Math.floor(t / e) + ' ' + o
        : Math.ceil(t / e) + ' ' + o + 's';
  }
});
var Ye = A((c, He) => {
  c = He.exports = pe.debug = pe.default = pe;
  c.coerce = go;
  c.disable = mo;
  c.enable = po;
  c.enabled = xo;
  c.humanize = Ve();
  c.names = [];
  c.skips = [];
  c.formatters = {};
  var ce;
  function co(t) {
    var e = 0,
      o;
    for (o in t) (e = (e << 5) - e + t.charCodeAt(o)), (e |= 0);
    return c.colors[Math.abs(e) % c.colors.length];
  }
  function pe(t) {
    function e() {
      if (e.enabled) {
        var o = e,
          r = +new Date(),
          i = r - (ce || r);
        (o.diff = i), (o.prev = ce), (o.curr = r), (ce = r);
        for (var n = new Array(arguments.length), s = 0; s < n.length; s++)
          n[s] = arguments[s];
        (n[0] = c.coerce(n[0])), typeof n[0] != 'string' && n.unshift('%O');
        var d = 0;
        (n[0] = n[0].replace(/%([a-zA-Z%])/g, function (a, u) {
          if (a === '%%') return a;
          d++;
          var f = c.formatters[u];
          if (typeof f == 'function') {
            var p = n[d];
            (a = f.call(o, p)), n.splice(d, 1), d--;
          }
          return a;
        })),
          c.formatArgs.call(o, n);
        var l = e.log || c.log || console.log.bind(console);
        l.apply(o, n);
      }
    }
    return (
      (e.namespace = t),
      (e.enabled = c.enabled(t)),
      (e.useColors = c.useColors()),
      (e.color = co(t)),
      typeof c.init == 'function' && c.init(e),
      e
    );
  }
  function po(t) {
    c.save(t), (c.names = []), (c.skips = []);
    for (
      var e = (typeof t == 'string' ? t : '').split(/[\s,]+/),
        o = e.length,
        r = 0;
      r < o;
      r++
    )
      e[r] &&
        ((t = e[r].replace(/\*/g, '.*?')),
        t[0] === '-'
          ? c.skips.push(new RegExp('^' + t.substr(1) + '$'))
          : c.names.push(new RegExp('^' + t + '$')));
  }
  function mo() {
    c.enable('');
  }
  function xo(t) {
    var e, o;
    for (e = 0, o = c.skips.length; e < o; e++)
      if (c.skips[e].test(t)) return !1;
    for (e = 0, o = c.names.length; e < o; e++)
      if (c.names[e].test(t)) return !0;
    return !1;
  }
  function go(t) {
    return t instanceof Error ? t.stack || t.message : t;
  }
});
var Qe = A((C, Ze) => {
  C = Ze.exports = Ye();
  C.log = _o;
  C.formatArgs = yo;
  C.save = vo;
  C.load = Je;
  C.useColors = ho;
  C.storage =
    typeof chrome != 'undefined' && typeof chrome.storage != 'undefined'
      ? chrome.storage.local
      : Co();
  C.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson',
  ];
  function ho() {
    return typeof window != 'undefined' &&
      window.process &&
      window.process.type === 'renderer'
      ? !0
      : (typeof document != 'undefined' &&
          document.documentElement &&
          document.documentElement.style &&
          document.documentElement.style.WebkitAppearance) ||
          (typeof window != 'undefined' &&
            window.console &&
            (window.console.firebug ||
              (window.console.exception && window.console.table))) ||
          (typeof navigator != 'undefined' &&
            navigator.userAgent &&
            navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
            parseInt(RegExp.$1, 10) >= 31) ||
          (typeof navigator != 'undefined' &&
            navigator.userAgent &&
            navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
  }
  C.formatters.j = function (t) {
    try {
      return JSON.stringify(t);
    } catch (e) {
      return '[UnexpectedJSONParseError]: ' + e.message;
    }
  };
  function yo(t) {
    var e = this.useColors;
    if (
      ((t[0] =
        (e ? '%c' : '') +
        this.namespace +
        (e ? ' %c' : ' ') +
        t[0] +
        (e ? '%c ' : ' ') +
        '+' +
        C.humanize(this.diff)),
      !!e)
    ) {
      var o = 'color: ' + this.color;
      t.splice(1, 0, o, 'color: inherit');
      var r = 0,
        i = 0;
      t[0].replace(/%[a-zA-Z%]/g, function (n) {
        n !== '%%' && (r++, n === '%c' && (i = r));
      }),
        t.splice(i, 0, o);
    }
  }
  function _o() {
    return (
      typeof console == 'object' &&
      console.log &&
      Function.prototype.apply.call(console.log, console, arguments)
    );
  }
  function vo(t) {
    try {
      t == null ? C.storage.removeItem('debug') : (C.storage.debug = t);
    } catch (e) {}
  }
  function Je() {
    var t;
    try {
      t = C.storage.debug;
    } catch (e) {}
    return (
      !t &&
        typeof process != 'undefined' &&
        'env' in process &&
        (t = process.env.DEBUG),
      t
    );
  }
  C.enable(Je());
  function Co() {
    try {
      return window.localStorage;
    } catch (t) {}
  }
});
var rt = A((wr, ot) => {
  var et = Qe()('cookie');
  ot.exports = function (t, e, o) {
    switch (arguments.length) {
      case 3:
      case 2:
        return wo(t, e, o);
      case 1:
        return Oo(t);
      default:
        return tt();
    }
  };
  function wo(t, e, o) {
    o = o || {};
    var r = Xe(t) + '=' + Xe(e);
    e == null && (o.maxage = -1),
      o.maxage && (o.expires = new Date(+new Date() + o.maxage)),
      o.path && (r += '; path=' + o.path),
      o.domain && (r += '; domain=' + o.domain),
      o.expires && (r += '; expires=' + o.expires.toUTCString()),
      o.secure && (r += '; secure'),
      (document.cookie = r);
  }
  function tt() {
    var t;
    try {
      t = document.cookie;
    } catch (e) {
      return (
        typeof console != 'undefined' &&
          typeof console.error == 'function' &&
          console.error(e.stack || e),
        {}
      );
    }
    return ko(t);
  }
  function Oo(t) {
    return tt()[t];
  }
  function ko(t) {
    var e = {},
      o = t.split(/ *; */),
      r;
    if (o[0] == '') return e;
    for (var i = 0; i < o.length; ++i)
      (r = o[i].split('=')), (e[$e(r[0])] = $e(r[1]));
    return e;
  }
  function Xe(t) {
    try {
      return encodeURIComponent(t);
    } catch (e) {
      et('error `encode(%o)` - %o', t, e);
    }
  }
  function $e(t) {
    try {
      return decodeURIComponent(t);
    } catch (e) {
      et('error `decode(%o)` - %o', t, e);
    }
  }
});
var it = A((J, nt) => {
  'use strict';
  var bo = We().parse,
    Io = rt();
  function me(t) {
    for (var e = J.cookie, o = J.levels(t), r = 0; r < o.length; ++r) {
      var i = '__tld__',
        n = o[r],
        s = { domain: '.' + n };
      if ((e(i, 1, s), e(i))) return e(i, null, s), n;
    }
    return '';
  }
  me.levels = function (t) {
    var e = bo(t).hostname,
      o = e.split('.'),
      r = o[o.length - 1],
      i = [];
    if ((o.length === 4 && r === parseInt(r, 10)) || o.length <= 1) return i;
    for (var n = o.length - 2; n >= 0; --n) i.push(o.slice(n).join('.'));
    return i;
  };
  me.cookie = Io;
  J = nt.exports = me;
});
var gt = A((Or, xe) => {
  'use strict';
  var B = typeof Reflect == 'object' ? Reflect : null,
    st =
      B && typeof B.apply == 'function'
        ? B.apply
        : function (e, o, r) {
            return Function.prototype.apply.call(e, o, r);
          },
    Z;
  B && typeof B.ownKeys == 'function'
    ? (Z = B.ownKeys)
    : Object.getOwnPropertySymbols
      ? (Z = function (e) {
          return Object.getOwnPropertyNames(e).concat(
            Object.getOwnPropertySymbols(e),
          );
        })
      : (Z = function (e) {
          return Object.getOwnPropertyNames(e);
        });
  function Po(t) {
    console && console.warn && console.warn(t);
  }
  var dt =
    Number.isNaN ||
    function (e) {
      return e !== e;
    };
  function m() {
    m.init.call(this);
  }
  xe.exports = m;
  xe.exports.once = So;
  m.EventEmitter = m;
  m.prototype._events = void 0;
  m.prototype._eventsCount = 0;
  m.prototype._maxListeners = void 0;
  var at = 10;
  function Q(t) {
    if (typeof t != 'function')
      throw new TypeError(
        'The "listener" argument must be of type Function. Received type ' +
          typeof t,
      );
  }
  Object.defineProperty(m, 'defaultMaxListeners', {
    enumerable: !0,
    get: function () {
      return at;
    },
    set: function (t) {
      if (typeof t != 'number' || t < 0 || dt(t))
        throw new RangeError(
          'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' +
            t +
            '.',
        );
      at = t;
    },
  });
  m.init = function () {
    (this._events === void 0 ||
      this._events === Object.getPrototypeOf(this)._events) &&
      ((this._events = Object.create(null)), (this._eventsCount = 0)),
      (this._maxListeners = this._maxListeners || void 0);
  };
  m.prototype.setMaxListeners = function (e) {
    if (typeof e != 'number' || e < 0 || dt(e))
      throw new RangeError(
        'The value of "n" is out of range. It must be a non-negative number. Received ' +
          e +
          '.',
      );
    return (this._maxListeners = e), this;
  };
  function lt(t) {
    return t._maxListeners === void 0 ? m.defaultMaxListeners : t._maxListeners;
  }
  m.prototype.getMaxListeners = function () {
    return lt(this);
  };
  m.prototype.emit = function (e) {
    for (var o = [], r = 1; r < arguments.length; r++) o.push(arguments[r]);
    var i = e === 'error',
      n = this._events;
    if (n !== void 0) i = i && n.error === void 0;
    else if (!i) return !1;
    if (i) {
      var s;
      if ((o.length > 0 && (s = o[0]), s instanceof Error)) throw s;
      var d = new Error('Unhandled error.' + (s ? ' (' + s.message + ')' : ''));
      throw ((d.context = s), d);
    }
    var l = n[e];
    if (l === void 0) return !1;
    if (typeof l == 'function') st(l, this, o);
    else
      for (var a = l.length, u = mt(l, a), r = 0; r < a; ++r) st(u[r], this, o);
    return !0;
  };
  function ut(t, e, o, r) {
    var i, n, s;
    if (
      (Q(o),
      (n = t._events),
      n === void 0
        ? ((n = t._events = Object.create(null)), (t._eventsCount = 0))
        : (n.newListener !== void 0 &&
            (t.emit('newListener', e, o.listener ? o.listener : o),
            (n = t._events)),
          (s = n[e])),
      s === void 0)
    )
      (s = n[e] = o), ++t._eventsCount;
    else if (
      (typeof s == 'function'
        ? (s = n[e] = r ? [o, s] : [s, o])
        : r
          ? s.unshift(o)
          : s.push(o),
      (i = lt(t)),
      i > 0 && s.length > i && !s.warned)
    ) {
      s.warned = !0;
      var d = new Error(
        'Possible EventEmitter memory leak detected. ' +
          s.length +
          ' ' +
          String(e) +
          ' listeners added. Use emitter.setMaxListeners() to increase limit',
      );
      (d.name = 'MaxListenersExceededWarning'),
        (d.emitter = t),
        (d.type = e),
        (d.count = s.length),
        Po(d);
    }
    return t;
  }
  m.prototype.addListener = function (e, o) {
    return ut(this, e, o, !1);
  };
  m.prototype.on = m.prototype.addListener;
  m.prototype.prependListener = function (e, o) {
    return ut(this, e, o, !0);
  };
  function Eo() {
    if (!this.fired)
      return (
        this.target.removeListener(this.type, this.wrapFn),
        (this.fired = !0),
        arguments.length === 0
          ? this.listener.call(this.target)
          : this.listener.apply(this.target, arguments)
      );
  }
  function ft(t, e, o) {
    var r = { fired: !1, wrapFn: void 0, target: t, type: e, listener: o },
      i = Eo.bind(r);
    return (i.listener = o), (r.wrapFn = i), i;
  }
  m.prototype.once = function (e, o) {
    return Q(o), this.on(e, ft(this, e, o)), this;
  };
  m.prototype.prependOnceListener = function (e, o) {
    return Q(o), this.prependListener(e, ft(this, e, o)), this;
  };
  m.prototype.removeListener = function (e, o) {
    var r, i, n, s, d;
    if ((Q(o), (i = this._events), i === void 0)) return this;
    if (((r = i[e]), r === void 0)) return this;
    if (r === o || r.listener === o)
      --this._eventsCount === 0
        ? (this._events = Object.create(null))
        : (delete i[e],
          i.removeListener && this.emit('removeListener', e, r.listener || o));
    else if (typeof r != 'function') {
      for (n = -1, s = r.length - 1; s >= 0; s--)
        if (r[s] === o || r[s].listener === o) {
          (d = r[s].listener), (n = s);
          break;
        }
      if (n < 0) return this;
      n === 0 ? r.shift() : Ao(r, n),
        r.length === 1 && (i[e] = r[0]),
        i.removeListener !== void 0 && this.emit('removeListener', e, d || o);
    }
    return this;
  };
  m.prototype.off = m.prototype.removeListener;
  m.prototype.removeAllListeners = function (e) {
    var o, r, i;
    if (((r = this._events), r === void 0)) return this;
    if (r.removeListener === void 0)
      return (
        arguments.length === 0
          ? ((this._events = Object.create(null)), (this._eventsCount = 0))
          : r[e] !== void 0 &&
            (--this._eventsCount === 0
              ? (this._events = Object.create(null))
              : delete r[e]),
        this
      );
    if (arguments.length === 0) {
      var n = Object.keys(r),
        s;
      for (i = 0; i < n.length; ++i)
        (s = n[i]), s !== 'removeListener' && this.removeAllListeners(s);
      return (
        this.removeAllListeners('removeListener'),
        (this._events = Object.create(null)),
        (this._eventsCount = 0),
        this
      );
    }
    if (((o = r[e]), typeof o == 'function')) this.removeListener(e, o);
    else if (o !== void 0)
      for (i = o.length - 1; i >= 0; i--) this.removeListener(e, o[i]);
    return this;
  };
  function ct(t, e, o) {
    var r = t._events;
    if (r === void 0) return [];
    var i = r[e];
    return i === void 0
      ? []
      : typeof i == 'function'
        ? o
          ? [i.listener || i]
          : [i]
        : o
          ? Do(i)
          : mt(i, i.length);
  }
  m.prototype.listeners = function (e) {
    return ct(this, e, !0);
  };
  m.prototype.rawListeners = function (e) {
    return ct(this, e, !1);
  };
  m.listenerCount = function (t, e) {
    return typeof t.listenerCount == 'function'
      ? t.listenerCount(e)
      : pt.call(t, e);
  };
  m.prototype.listenerCount = pt;
  function pt(t) {
    var e = this._events;
    if (e !== void 0) {
      var o = e[t];
      if (typeof o == 'function') return 1;
      if (o !== void 0) return o.length;
    }
    return 0;
  }
  m.prototype.eventNames = function () {
    return this._eventsCount > 0 ? Z(this._events) : [];
  };
  function mt(t, e) {
    for (var o = new Array(e), r = 0; r < e; ++r) o[r] = t[r];
    return o;
  }
  function Ao(t, e) {
    for (; e + 1 < t.length; e++) t[e] = t[e + 1];
    t.pop();
  }
  function Do(t) {
    for (var e = new Array(t.length), o = 0; o < e.length; ++o)
      e[o] = t[o].listener || t[o];
    return e;
  }
  function So(t, e) {
    return new Promise(function (o, r) {
      function i(s) {
        t.removeListener(e, n), r(s);
      }
      function n() {
        typeof t.removeListener == 'function' && t.removeListener('error', i),
          o([].slice.call(arguments));
      }
      xt(t, e, n, { once: !0 }), e !== 'error' && Lo(t, i, { once: !0 });
    });
  }
  function Lo(t, e, o) {
    typeof t.on == 'function' && xt(t, 'error', e, o);
  }
  function xt(t, e, o, r) {
    if (typeof t.on == 'function') r.once ? t.once(e, o) : t.on(e, o);
    else if (typeof t.addEventListener == 'function')
      t.addEventListener(e, function i(n) {
        r.once && t.removeEventListener(e, i), o(n);
      });
    else
      throw new TypeError(
        'The "emitter" argument must be of type EventEmitter. Received type ' +
          typeof t,
      );
  }
});
var Bt = A((Mt, Ft) => {
  (function (t) {
    var e = !1;
    if (
      (typeof define == 'function' && define.amd && (define(t), (e = !0)),
      typeof Mt == 'object' && ((Ft.exports = t()), (e = !0)),
      !e)
    ) {
      var o = window.Cookies,
        r = (window.Cookies = t());
      r.noConflict = function () {
        return (window.Cookies = o), r;
      };
    }
  })(function () {
    function t() {
      for (var o = 0, r = {}; o < arguments.length; o++) {
        var i = arguments[o];
        for (var n in i) r[n] = i[n];
      }
      return r;
    }
    function e(o) {
      function r(i, n, s) {
        var d;
        if (typeof document != 'undefined') {
          if (arguments.length > 1) {
            if (
              ((s = t({ path: '/' }, r.defaults, s)),
              typeof s.expires == 'number')
            ) {
              var l = new Date();
              l.setMilliseconds(l.getMilliseconds() + s.expires * 864e5),
                (s.expires = l);
            }
            s.expires = s.expires ? s.expires.toUTCString() : '';
            try {
              (d = JSON.stringify(n)), /^[\{\[]/.test(d) && (n = d);
            } catch (w) {}
            o.write
              ? (n = o.write(n, i))
              : (n = encodeURIComponent(String(n)).replace(
                  /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                  decodeURIComponent,
                )),
              (i = encodeURIComponent(String(i))),
              (i = i.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)),
              (i = i.replace(/[\(\)]/g, escape));
            var a = '';
            for (var u in s)
              s[u] && ((a += '; ' + u), s[u] !== !0 && (a += '=' + s[u]));
            return (document.cookie = i + '=' + n + a);
          }
          i || (d = {});
          for (
            var f = document.cookie ? document.cookie.split('; ') : [],
              p = /(%[0-9A-Z]{2})+/g,
              x = 0;
            x < f.length;
            x++
          ) {
            var y = f[x].split('='),
              g = y.slice(1).join('=');
            !this.json && g.charAt(0) === '"' && (g = g.slice(1, -1));
            try {
              var b = y[0].replace(p, decodeURIComponent);
              if (
                ((g = o.read
                  ? o.read(g, b)
                  : o(g, b) || g.replace(p, decodeURIComponent)),
                this.json)
              )
                try {
                  g = JSON.parse(g);
                } catch (w) {}
              if (i === b) {
                d = g;
                break;
              }
              i || (d[b] = g);
            } catch (w) {}
          }
          return d;
        }
      }
      return (
        (r.set = r),
        (r.get = function (i) {
          return r.call(r, i);
        }),
        (r.getJSON = function () {
          return r.apply({ json: !0 }, [].slice.call(arguments));
        }),
        (r.defaults = {}),
        (r.remove = function (i, n) {
          r(i, '', t(n, { expires: -1 }));
        }),
        (r.withConverter = e),
        r
      );
    }
    return e(function () {});
  });
});
import H, {
  Fragment as cr,
  memo as pr,
  useEffect as mr,
  useMemo as xr,
  useState as gr,
} from 'react';
var bt = j(fe());
import { Component as qo } from 'react';
var he = j(fe()),
  ht = j(it()),
  yt = j(gt()),
  ge = function () {
    return (
      (ge =
        Object.assign ||
        function (t) {
          for (var e, o = 1, r = arguments.length; o < r; o++) {
            e = arguments[o];
            for (var i in e)
              Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          }
          return t;
        }),
      ge.apply(this, arguments)
    );
  },
  X = 'tracking-preferences',
  No = 365;
function ye(t) {
  var e = he.default.getJSON(t || X);
  return e
    ? { destinationPreferences: e.destinations, customPreferences: e.custom }
    : {};
}
var To = new yt.EventEmitter();
function _t(t) {
  var e = t.destinationPreferences,
    o = t.customPreferences,
    r = t.cookieDomain,
    i = t.cookieName,
    n = t.cookieExpires,
    s = t.cookieAttributes,
    d = s === void 0 ? {} : s,
    l = window;
  l.analytics &&
    l.analytics.identify({
      destinationTrackingPreferences: e,
      customTrackingPreferences: o,
    });
  var a = r || (0, ht.default)(window.location.href),
    u = n || No,
    f = { version: 1, destinations: e, custom: o };
  he.default.set(i || X, f, ge({ expires: u, domain: a }, d)),
    To.emit('preferencesSaved', {
      destinationPreferences: e,
      customPreferences: o,
    });
}
import Ro from 'isomorphic-fetch';
import zo from 'lodash/flatten';
import Mo from 'lodash/sortedUniqBy';
import Fo from 'lodash/sortBy';
var vt = function (t, e, o, r) {
    function i(n) {
      return n instanceof o
        ? n
        : new o(function (s) {
            s(n);
          });
    }
    return new (o || (o = Promise))(function (n, s) {
      function d(u) {
        try {
          a(r.next(u));
        } catch (f) {
          s(f);
        }
      }
      function l(u) {
        try {
          a(r.throw(u));
        } catch (f) {
          s(f);
        }
      }
      function a(u) {
        u.done ? n(u.value) : i(u.value).then(d, l);
      }
      a((r = r.apply(t, e || [])).next());
    });
  },
  Ct = function (t, e) {
    var o = {
        label: 0,
        sent: function () {
          if (n[0] & 1) throw n[1];
          return n[1];
        },
        trys: [],
        ops: [],
      },
      r,
      i,
      n,
      s;
    return (
      (s = { next: d(0), throw: d(1), return: d(2) }),
      typeof Symbol == 'function' &&
        (s[Symbol.iterator] = function () {
          return this;
        }),
      s
    );
    function d(a) {
      return function (u) {
        return l([a, u]);
      };
    }
    function l(a) {
      if (r) throw new TypeError('Generator is already executing.');
      for (; o; )
        try {
          if (
            ((r = 1),
            i &&
              (n =
                a[0] & 2
                  ? i.return
                  : a[0]
                    ? i.throw || ((n = i.return) && n.call(i), 0)
                    : i.next) &&
              !(n = n.call(i, a[1])).done)
          )
            return n;
          switch (((i = 0), n && (a = [a[0] & 2, n.value]), a[0])) {
            case 0:
            case 1:
              n = a;
              break;
            case 4:
              return o.label++, { value: a[1], done: !1 };
            case 5:
              o.label++, (i = a[1]), (a = [0]);
              continue;
            case 7:
              (a = o.ops.pop()), o.trys.pop();
              continue;
            default:
              if (
                ((n = o.trys),
                !(n = n.length > 0 && n[n.length - 1]) &&
                  (a[0] === 6 || a[0] === 2))
              ) {
                o = 0;
                continue;
              }
              if (a[0] === 3 && (!n || (a[1] > n[0] && a[1] < n[3]))) {
                o.label = a[1];
                break;
              }
              if (a[0] === 6 && o.label < n[1]) {
                (o.label = n[1]), (n = a);
                break;
              }
              if (n && o.label < n[2]) {
                (o.label = n[2]), o.ops.push(a);
                break;
              }
              n[2] && o.ops.pop(), o.trys.pop();
              continue;
          }
          a = e.call(t, o);
        } catch (u) {
          (a = [6, u]), (i = 0);
        } finally {
          r = n = 0;
        }
      if (a[0] & 5) throw a[1];
      return { value: a[0] ? a[1] : void 0, done: !0 };
    }
  };
function Bo(t, e) {
  return vt(this, void 0, void 0, function () {
    var o, r, i, n, s;
    return Ct(this, function (d) {
      switch (d.label) {
        case 0:
          return [
            4,
            Ro('https://' + t + '/v1/projects/' + e + '/integrations'),
          ];
        case 1:
          if (((o = d.sent()), !o.ok))
            throw new Error(
              'Failed to fetch integrations for write key ' +
                e +
                ': HTTP ' +
                o.status +
                ' ' +
                o.statusText,
            );
          return [4, o.json()];
        case 2:
          for (r = d.sent(), i = 0, n = r; i < n.length; i++)
            (s = n[i]),
              s.name === 'Fullstory'
                ? (s.id = s.name)
                : (s.id = s.creationName),
              delete s.creationName;
          return [2, r];
      }
    });
  });
}
function _e(t, e) {
  return vt(this, void 0, void 0, function () {
    var o, r, i, n, s, d;
    return Ct(this, function (l) {
      switch (l.label) {
        case 0:
          for (o = [], r = 0, i = e; r < i.length; r++)
            (n = i[r]), o.push(Bo(t, n));
          return (d = zo), [4, Promise.all(o)];
        case 1:
          return (
            (s = d.apply(void 0, [l.sent()])),
            (s = s.filter(function (a) {
              return a.id !== 'Repeater';
            })),
            (s = Fo(s, ['id'])),
            (s = Mo(s, 'id')),
            [2, s]
          );
      }
    });
  });
}
function Go(t, e, o) {
  return function (r) {
    var i = r.payload,
      n = r.next;
    (i.obj.context.consent = {
      defaultDestinationBehavior: o,
      categoryPreferences: e,
      destinationPreferences: t,
    }),
      n(i);
  };
}
function $(t) {
  var e = t.writeKey,
    o = t.destinations,
    r = t.hasConsent,
    i = t.destinationPreferences,
    n = t.isConsentRequired,
    s = t.shouldReload,
    d = s === void 0 ? !0 : s,
    l = t.devMode,
    a = l === void 0 ? !1 : l,
    u = t.defaultDestinationBehavior,
    f = t.categoryPreferences,
    p = window,
    x = { 'Segment.io': !0 },
    y = !1;
  if (!i) {
    if (n) return;
    p.analytics.initialized || p.analytics.load(e);
    return;
  }
  for (var g = 0, b = o; g < b.length; g++) {
    var w = b[g],
      P = w.id in i;
    if (!P && u === 'enable') {
      x[w.id] = !0;
      continue;
    }
    var O = !!i[w.id];
    O && (y = !0), (x[w.id] = O);
  }
  if (p.analytics && p.analytics.initialized) {
    d && window.location.reload();
    return;
  }
  if (!a && y && (r || !n)) {
    var _ = Go(i, f, u);
    p.analytics.addSourceMiddleware(_),
      p.analytics.load(e, { integrations: x });
  }
}
var Uo = (function () {
    var t = function (e, o) {
      return (
        (t =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (r, i) {
              r.__proto__ = i;
            }) ||
          function (r, i) {
            for (var n in i) i.hasOwnProperty(n) && (r[n] = i[n]);
          }),
        t(e, o)
      );
    };
    return function (e, o) {
      t(e, o);
      function r() {
        this.constructor = e;
      }
      e.prototype =
        o === null ? Object.create(o) : ((r.prototype = o.prototype), new r());
    };
  })(),
  N = function () {
    return (
      (N =
        Object.assign ||
        function (t) {
          for (var e, o = 1, r = arguments.length; o < r; o++) {
            e = arguments[o];
            for (var i in e)
              Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          }
          return t;
        }),
      N.apply(this, arguments)
    );
  },
  wt = function (t, e, o, r) {
    function i(n) {
      return n instanceof o
        ? n
        : new o(function (s) {
            s(n);
          });
    }
    return new (o || (o = Promise))(function (n, s) {
      function d(u) {
        try {
          a(r.next(u));
        } catch (f) {
          s(f);
        }
      }
      function l(u) {
        try {
          a(r.throw(u));
        } catch (f) {
          s(f);
        }
      }
      function a(u) {
        u.done ? n(u.value) : i(u.value).then(d, l);
      }
      a((r = r.apply(t, e || [])).next());
    });
  },
  Ot = function (t, e) {
    var o = {
        label: 0,
        sent: function () {
          if (n[0] & 1) throw n[1];
          return n[1];
        },
        trys: [],
        ops: [],
      },
      r,
      i,
      n,
      s;
    return (
      (s = { next: d(0), throw: d(1), return: d(2) }),
      typeof Symbol == 'function' &&
        (s[Symbol.iterator] = function () {
          return this;
        }),
      s
    );
    function d(a) {
      return function (u) {
        return l([a, u]);
      };
    }
    function l(a) {
      if (r) throw new TypeError('Generator is already executing.');
      for (; o; )
        try {
          if (
            ((r = 1),
            i &&
              (n =
                a[0] & 2
                  ? i.return
                  : a[0]
                    ? i.throw || ((n = i.return) && n.call(i), 0)
                    : i.next) &&
              !(n = n.call(i, a[1])).done)
          )
            return n;
          switch (((i = 0), n && (a = [a[0] & 2, n.value]), a[0])) {
            case 0:
            case 1:
              n = a;
              break;
            case 4:
              return o.label++, { value: a[1], done: !1 };
            case 5:
              o.label++, (i = a[1]), (a = [0]);
              continue;
            case 7:
              (a = o.ops.pop()), o.trys.pop();
              continue;
            default:
              if (
                ((n = o.trys),
                !(n = n.length > 0 && n[n.length - 1]) &&
                  (a[0] === 6 || a[0] === 2))
              ) {
                o = 0;
                continue;
              }
              if (a[0] === 3 && (!n || (a[1] > n[0] && a[1] < n[3]))) {
                o.label = a[1];
                break;
              }
              if (a[0] === 6 && o.label < n[1]) {
                (o.label = n[1]), (n = a);
                break;
              }
              if (n && o.label < n[2]) {
                (o.label = n[2]), o.ops.push(a);
                break;
              }
              n[2] && o.ops.pop(), o.trys.pop();
              continue;
          }
          a = e.call(t, o);
        } catch (u) {
          (a = [6, u]), (i = 0);
        } finally {
          r = n = 0;
        }
      if (a[0] & 5) throw a[1];
      return { value: a[0] ? a[1] : void 0, done: !0 };
    }
  },
  jo = function () {
    for (var t = 0, e = 0, o = arguments.length; e < o; e++)
      t += arguments[e].length;
    for (var r = Array(t), i = 0, e = 0; e < o; e++)
      for (var n = arguments[e], s = 0, d = n.length; s < d; s++, i++)
        r[i] = n[s];
    return r;
  };
function kt(t, e) {
  var o = [];
  if (!e) return t;
  for (var r = 0, i = t; r < i.length; r++) {
    var n = i[r];
    e[n.id] === void 0 && o.push(n);
  }
  return o;
}
var Wo = (function (t) {
    Uo(e, t);
    function e() {
      var o = (t !== null && t.apply(this, arguments)) || this;
      return (
        (o.state = {
          isLoading: !0,
          destinations: [],
          newDestinations: [],
          preferences: {},
          destinationPreferences: {},
          isConsentRequired: !0,
          havePreferencesChanged: !1,
          workspaceAddedNewDestinations: !1,
        }),
        (o.hasConsent = function () {
          return !!bt.default.get(this.props.cookieName || X);
        }),
        (o.initialise = function () {
          return wt(o, void 0, void 0, function () {
            var r,
              i,
              n,
              s,
              d,
              l,
              a,
              u,
              f,
              p,
              x,
              y,
              g,
              b,
              w,
              P,
              O,
              _,
              S,
              M,
              se,
              U,
              ae,
              de,
              F,
              ze,
              Me,
              le;
            return Ot(this, function (Fe) {
              switch (Fe.label) {
                case 0:
                  return (
                    (r = this.props),
                    (i = r.writeKey),
                    (n = r.otherWriteKeys),
                    (s = n === void 0 ? e.defaultProps.otherWriteKeys : n),
                    (d = r.shouldRequireConsent),
                    (l =
                      d === void 0 ? e.defaultProps.shouldRequireConsent : d),
                    (a = r.initialPreferences),
                    (u = r.mapCustomPreferences),
                    (f = r.defaultDestinationBehavior),
                    (p = r.cookieName),
                    (x = r.cdnHost),
                    (y = x === void 0 ? e.defaultProps.cdnHost : x),
                    (g = r.shouldReload),
                    (b = g === void 0 ? e.defaultProps.shouldReload : g),
                    (w = r.devMode),
                    (P = w === void 0 ? e.defaultProps.devMode : w),
                    (O = ye(p)),
                    (_ = O.destinationPreferences),
                    (S = O.customPreferences),
                    [4, Promise.all([l(), _e(y, jo([i], s))])]
                  );
                case 1:
                  return (
                    (M = Fe.sent()),
                    (se = M[0]),
                    (U = M[1]),
                    (ae = kt(U, _ || {})),
                    (de = _ && Object.keys(_).length > 0 && ae.length > 0),
                    (ze = Object.values(a || {}).some(function (R) {
                      return R === !0 || R === !1 || R === 'N/A';
                    })),
                    (Me = Object.values(S || {}).every(function (R) {
                      return R == null || R === 'N/A';
                    })),
                    u
                      ? ((F = S || a || {}),
                        ((ze && Me) || (f === 'imply' && de)) &&
                          ((le = u(U, F)),
                          (_ = le.destinationPreferences),
                          (S = le.customPreferences),
                          (F = S)))
                      : (F = _ || a),
                    $({
                      writeKey: i,
                      destinations: U,
                      destinationPreferences: _,
                      isConsentRequired: se,
                      shouldReload: b,
                      devMode: P,
                      defaultDestinationBehavior: f,
                      categoryPreferences: F,
                      hasConsent: this.hasConsent(),
                    }),
                    this.setState({
                      isLoading: !1,
                      destinations: U,
                      newDestinations: ae,
                      preferences: F,
                      isConsentRequired: se,
                      destinationPreferences: _,
                      workspaceAddedNewDestinations: !!de,
                    }),
                    [2]
                  );
              }
            });
          });
        }),
        (o.handleSetPreferences = function (r) {
          o.setState(function (i) {
            var n = i.destinations,
              s = i.preferences,
              d = o.mergePreferences({
                destinations: n,
                newPreferences: r,
                existingPreferences: s,
              });
            return N(N({}, i), { preferences: d, havePreferencesChanged: !0 });
          });
        }),
        (o.handleResetPreferences = function () {
          var r = o.props,
            i = r.initialPreferences,
            n = r.mapCustomPreferences,
            s = r.cookieName,
            d = ye(s),
            l = d.destinationPreferences,
            a = d.customPreferences,
            u;
          n ? (u = a || i) : (u = l || i), o.setState({ preferences: u });
        }),
        (o.handleSaveConsent = function (r, i, n) {
          var s = o.props,
            d = s.writeKey,
            l = s.cookieDomain,
            a = s.cookieName,
            u = s.cookieExpires,
            f = s.cookieAttributes,
            p = s.mapCustomPreferences,
            x = s.defaultDestinationBehavior;
          o.setState(function (y) {
            var g = y.destinations,
              b = y.preferences,
              w = y.isConsentRequired,
              P = o.mergePreferences({
                destinations: g,
                newPreferences: r,
                existingPreferences: b,
              }),
              O,
              _;
            if (p) {
              var S = p(g, P);
              (O = S.destinationPreferences),
                (_ = S.customPreferences),
                _ ? (P = _) : (_ = P);
            } else O = P;
            var M = kt(g, O);
            return (
              (y.havePreferencesChanged ||
                M.length > 0 ||
                typeof r == 'boolean') &&
                (i = !0),
              _t({
                destinationPreferences: O,
                customPreferences: _,
                cookieDomain: l,
                cookieName: a,
                cookieExpires: u,
                cookieAttributes: f,
              }),
              $({
                writeKey: d,
                destinations: g,
                destinationPreferences: O,
                isConsentRequired: w,
                shouldReload: i,
                devMode: n,
                defaultDestinationBehavior: x,
                categoryPreferences: _,
                hasConsent: !0,
              }),
              N(N({}, y), {
                destinationPreferences: O,
                preferences: P,
                newDestinations: M,
              })
            );
          });
        }),
        (o.mergePreferences = function (r) {
          var i = r.destinations,
            n = r.existingPreferences,
            s = r.newPreferences,
            d;
          if (typeof s == 'boolean') {
            for (var l = {}, a = 0, u = i; a < u.length; a++) {
              var f = u[a];
              l[f.id] = s;
            }
            d = l;
          } else s ? (d = N(N({}, n), s)) : (d = n);
          return d;
        }),
        o
      );
    }
    return (
      (e.prototype.render = function () {
        var o = this.props,
          r = o.children,
          i = o.customCategories,
          n = this.state,
          s = n.isLoading,
          d = n.destinations,
          l = n.preferences,
          a = n.newDestinations,
          u = n.isConsentRequired,
          f = n.havePreferencesChanged,
          p = n.workspaceAddedNewDestinations,
          x = n.destinationPreferences;
        return s
          ? null
          : r({
              destinations: d,
              customCategories: i,
              newDestinations: a,
              preferences: l,
              isConsentRequired: u,
              havePreferencesChanged: f,
              workspaceAddedNewDestinations: p,
              destinationPreferences: x,
              setPreferences: this.handleSetPreferences,
              resetPreferences: this.handleResetPreferences,
              saveConsent: this.handleSaveConsent,
            });
      }),
      (e.prototype.componentDidMount = function () {
        return wt(this, void 0, void 0, function () {
          var o, r;
          return Ot(this, function (i) {
            switch (i.label) {
              case 0:
                if (((o = this.props.onError), !(o && typeof o == 'function')))
                  return [3, 6];
                i.label = 1;
              case 1:
                return i.trys.push([1, 3, , 5]), [4, this.initialise()];
              case 2:
                return i.sent(), [3, 5];
              case 3:
                return (r = i.sent()), [4, o(r)];
              case 4:
                return i.sent(), [3, 5];
              case 5:
                return [3, 8];
              case 6:
                return [4, this.initialise()];
              case 7:
                i.sent(), (i.label = 8);
              case 8:
                return [2];
            }
          });
        });
      }),
      (e.displayName = 'ConsentManagerBuilder'),
      (e.defaultProps = {
        otherWriteKeys: [],
        onError: void 0,
        shouldRequireConsent: function () {
          return !0;
        },
        initialPreferences: {},
        cdnHost: 'cdn.segment.com',
        shouldReload: !0,
        devMode: !1,
      }),
      e
    );
  })(qo),
  It = Wo;
var Pt = It;
var G = ((r) => (
    (r.ANALYTICS = 'marketingAndAnalytics'),
    (r.ADVERTISING = 'advertising'),
    (r.FUNCTIONAL = 'functional'),
    r
  ))(G || {}),
  Et = { marketingAndAnalytics: !1, advertising: !1, functional: !0 },
  ee = Object.values(G).reduce((t, e) => E(v({}, t), { [e]: !0 }), {}),
  At = [
    {
      category: 'functional',
      labelKey: 'expanded_essential',
      descriptionKey: 'expanded_essential_description',
    },
    {
      category: 'marketingAndAnalytics',
      labelKey: 'expanded_analytics',
      descriptionKey: 'expanded_analytics_description',
    },
    {
      category: 'advertising',
      labelKey: 'expanded_marketing',
      descriptionKey: 'expanded_marketing_description',
    },
  ],
  Dt = ['Analytics', 'Email Marketing'],
  St = ['Advertising', 'Tag Managers'],
  Lt = ['Customer Success'];
function Nt(...t) {
  var o;
  let e = globalThis.window;
  (e.dataLayer = e.dataLayer || []),
    (o = e.dataLayer) == null || o.push(arguments);
}
var Tt = () => {
    Nt('consent', 'default', {
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      ad_storage: 'denied',
      analytics_storage: 'denied',
    });
  },
  ve = () => {
    Nt('consent', 'update', {
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted',
    });
  };
var Ko = (t) => {
    let e = t.match(/(\[)(.*?)(\])/gi);
    return e ? e[2] : null;
  },
  Vo = (t) =>
    t.map((e) => {
      let o = Ko(e.id);
      return o ? E(v({}, e), { category: o }) : e;
    }),
  Rt = (t) => (e) => e.toLowerCase() === t.category.toLowerCase(),
  Ho = { advertising: St, marketingAndAnalytics: Dt },
  Yo = ['marketingAndAnalytics', 'advertising'],
  zt = (t, e) => {
    let o = {},
      r = {},
      i = Vo(t);
    return (
      Object.keys(e).forEach((n) => {
        let s = e[n];
        typeof s == 'boolean' ? (r[n] = s) : (r[n] = !0);
      }),
      i.forEach((n) => {
        Yo.forEach((s) => {
          Ho[s].find(Rt(n)) && o[n.id] !== !1 && (o[n.id] = r[s]);
        }),
          Lt.find(Rt(n)) && (o[n.id] = !0),
          n.id in o || (o[n.id] = r.marketingAndAnalytics);
      }),
      { destinationPreferences: o, customPreferences: r }
    );
  };
var Gt = j(Bt());
var te = () => !(window != null && window.ReactNativeWebView),
  Ut = () => Et,
  Jo = 'tracking-preferences',
  Ce = { marketingAndAnalytics: !1, advertising: !1, functional: !0 },
  we = () => Gt.default.get(Jo),
  Zo = () => {
    if (!te()) return ee;
    let t = we();
    if (!t) return Ce;
    try {
      let e = JSON.parse(decodeURIComponent(t));
      return 'custom' in e && typeof e.custom == 'object' ? e.custom : Ce;
    } catch (e) {
      return Ce;
    }
  },
  Oe = () => Zo().marketingAndAnalytics;
var Qo = (t = []) => {
  var o, r;
  let e = (window.analytics = window.analytics || []);
  if ((Tt(), !e.initialize))
    if (e.invoked) console.error('Segment snippet included twice.');
    else {
      (e.invoked = !0),
        (e.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on',
          'register',
          'addSourceMiddleware',
          'addIntegrationMiddleware',
          'setAnonymousId',
          'addDestinationMiddleware',
        ]),
        (e.factory = function (i) {
          return function () {
            let n = Array.prototype.slice.call(arguments);
            return n.unshift(i), e.push(n), e;
          };
        });
      for (let i = 0; i < e.methods.length; i++) {
        let n = e.methods[i];
        e[n] = e.factory(n);
      }
      (e.load = function (i, n) {
        var l;
        let s = document.createElement('script');
        (s.type = 'text/javascript'),
          (s.async = !0),
          (s.src =
            'https://cdn.segment.com/analytics.js/v1/' +
            i +
            '/analytics.min.js');
        let d = document.getElementsByTagName('script')[0];
        (l = d.parentNode) == null || l.insertBefore(s, d),
          (e._loadOptions = n);
      }),
        (e.SNIPPET_VERSION = '4.13.2'),
        (r = (o = window.analytics) == null ? void 0 : o.register) == null ||
          r.call(o, ...t),
        e.page();
    }
};
import D from 'react';
import * as ke from 'react';
var Xo = (t) =>
    ke.createElement(
      'svg',
      v(
        {
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg',
        },
        t,
      ),
      ke.createElement('path', {
        d: 'M20 6 9 17l-5-5',
        stroke: 'currentColor',
        strokeWidth: 1.5,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
    ),
  be = Xo;
import * as Ie from 'react';
var $o = (t) =>
    Ie.createElement(
      'svg',
      v(
        {
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg',
        },
        t,
      ),
      Ie.createElement('path', {
        d: 'm6 9 6 6 6-6',
        stroke: 'currentColor',
        strokeWidth: 1.5,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
    ),
  Pe = $o;
import * as Ee from 'react';
var er = (t) =>
    Ee.createElement(
      'svg',
      v(
        {
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg',
        },
        t,
      ),
      Ee.createElement('path', {
        d: 'm18 15-6-6-6 6',
        stroke: 'currentColor',
        strokeWidth: 1.5,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
    ),
  Ae = er;
import { Button as Se, Typography as Jt } from '@getquin/ui-kit';
var jt = {
  collapsed_title: 'D\xFCrfen wir Cookies benutzen?',
  collapsed_subtitle:
    'Cookies helfen uns, Dein Erlebnis zu verbessern, Anzeigen auf deine Interessen abzustimmen und unsere Webseite zu optimieren. Erfahre mehr und verwalte Deine Einstellungen ',
  collapsed_subtitle_here: 'hier',
  collapsed_decline: 'Ablehnen',
  collapsed_accept: 'Akzeptieren',
  expanded_title: 'Cookies-Manager',
  expanded_subtitle:
    'Wenn Du unsere Website besuchst, verwenden wir Cookies und \xE4hnliche Technologien, um Dir ein sicheres und zuverl\xE4ssiges Erlebnis zu bieten. Einige Cookies sind f\xFCr die Funktionalit\xE4t unserer Website unerl\xE4sslich und bed\xFCrfen nicht Deiner Zustimmung. Dar\xFCber hinaus verwenden wir auch nicht essenzielle Cookies, um unsere Dienstleistungen und Marketingaktivit\xE4ten anzupassen. Wir bitten Dich um Deine ausdr\xFCckliche Zustimmung, bevor wir nicht essentielle Cookies einsetzen. Wir danken Dir f\xFCr Deinen Besuch auf unserer Website und daf\xFCr, dass Du uns Deine Datenschutzpr\xE4ferenzen anvertraust.',
  expanded_learn_more: 'Erfahre mehr \xFCber unsere Cookies:',
  expanded_learn_more_google:
    'Wir nutzen Google und andere Dienste f\xFCr unser Marketing:',
  expanded_cookie_policy: 'Cookie-Richtlinie',
  expanded_cookie_policy_google: 'Google Cookie-Richtlinie',
  expanded_accept_all: 'Akzeptiere alle Cookies',
  expanded_confirm_my_choices: 'Auswahl best\xE4tigen',
  expanded_preferences_title: 'Pr\xE4ferenzen f\xFCr die Einwilligung',
  expanded_always_active: 'Immer aktiv',
  expanded_essential: 'Notwendig',
  expanded_essential_description:
    'Diese Cookies sind f\xFCr das Funktionieren der Webseite notwendig. Deshalb k\xF6nnen sie nicht ausgeschaltet werden.',
  expanded_analytics: 'Analytics',
  expanded_analytics_description:
    'Analytics Cookies sammeln Daten \xFCber die Nutzung der Webseite. Diese Daten helfen uns den Inhalt der Webseite kontinuierlich zu verbessern.',
  expanded_marketing: 'Marketing',
  expanded_marketing_description:
    'Marketing Cookies sammeln Informationen \xFCber Werbekampagnen und deren Erfolg. Dies hilft uns Werbung an Deine Interessen anzupassen.',
};
var qt = {
  collapsed_title: 'Are we allowed to use cookies?',
  collapsed_subtitle:
    'Cookies help us to improve your experience, tailor ads to your interests and optimize our website. Learn more and manage settings ',
  collapsed_subtitle_here: 'here',
  collapsed_decline: 'Reject',
  collapsed_accept: 'Accept',
  expanded_title: 'Cookies Manager',
  expanded_subtitle:
    'When you visit our website, we employ cookies and similar technologies to provide you with a safe and reliable experience. Some cookies are essential to the functionality of our website and do not require your consent. Besides, we also use non-essential cookies to tailor our services and marketing activities. We seek your explicit consent before deploying any non-essential cookies. Thank you for choosing to visit our website and for entrusting us with your privacy preferences.',
  expanded_learn_more: 'Learn more about our cookies:',
  expanded_learn_more_google: 'We use Google and other services for marketing:',
  expanded_cookie_policy: 'Cookies policy',
  expanded_cookie_policy_google: 'Google Cookies policy',
  expanded_accept_all: 'Accept All',
  expanded_confirm_my_choices: 'Confirm my choices',
  expanded_preferences_title: 'Consent preferences',
  expanded_always_active: 'Always active',
  expanded_essential: 'Essential',
  expanded_essential_description:
    'These cookies are necessary for the functioning of the website. Therefore they cannot be turned off.',
  expanded_analytics: 'Analytics',
  expanded_analytics_description:
    'Analytics Cookies collect data about the use of the website. This data helps us to continuously improve the content of the website.',
  expanded_marketing: 'Marketing',
  expanded_marketing_description:
    'Marketing cookies collect information about advertising campaigns and their success. This helps us to tailor advertising to your interests.',
};
var Wt = {
  collapsed_title: '\xBFPodemos utilizar cookies?',
  collapsed_subtitle:
    'Las cookies nos ayudan a mejorar su experiencia, adaptar los anuncios a sus intereses y optimizar nuestro sitio web. M\xE1s informaci\xF3n y configuraci\xF3n ',
  collapsed_subtitle_here: 'aqu\xED',
  collapsed_decline: 'Rechace',
  collapsed_accept: 'Acepte',
  expanded_title: 'Cookies Manager',
  expanded_subtitle:
    'Cuando visita nuestro sitio web, utilizamos cookies y tecnolog\xEDas similares para ofrecerle una experiencia segura y fiable. Algunas cookies son esenciales para la funcionalidad de nuestro sitio web y no requieren su consentimiento. Adem\xE1s, tambi\xE9n utilizamos cookies no esenciales para adaptar nuestros servicios y actividades de marketing. Solicitamos su consentimiento expl\xEDcito antes de desplegar cualquier cookie no esencial. Gracias por visitar nuestro sitio web y por confiarnos sus preferencias de privacidad.',
  expanded_learn_more: 'M\xE1s informaci\xF3n sobre nuestras cookies:',
  expanded_learn_more_google:
    'Utilizamos Google y otros servicios para marketing:',
  expanded_cookie_policy: 'Pol\xEDtica de cookies',
  expanded_cookie_policy_google: 'Google Pol\xEDtica de cookies',
  expanded_accept_all: 'Aceptar todas las cookies',
  expanded_confirm_my_choices: 'Confirmar mis elecciones',
  expanded_preferences_title: 'Preferencias de consentimiento',
  expanded_always_active: 'Siempre activo',
  expanded_essential: 'Necesario',
  expanded_essential_description:
    'Estas cookies son necesarias para que el sitio web funcione. Por lo tanto, no se pueden desactivar.',
  expanded_analytics: 'Analytics',
  expanded_analytics_description:
    'Las cookies anal\xEDticas recopilan datos sobre c\xF3mo se utiliza el sitio web. Estos datos nos ayudan a mejorar continuamente el contenido del sitio web.',
  expanded_marketing: 'Marketing',
  expanded_marketing_description:
    'Las cookies de marketing recopilan informaci\xF3n sobre las campa\xF1as publicitarias y su \xE9xito. Esto nos ayuda a personalizar la publicidad seg\xFAn sus intereses.',
};
var Kt = {
  collapsed_title: "Avons-nous le droit d'utiliser des cookies ?",
  collapsed_subtitle:
    'Les cookies nous aident \xE0 am\xE9liorer votre exp\xE9rience, \xE0 adapter les publicit\xE9s \xE0 vos int\xE9r\xEAts et \xE0 optimiser notre site web. En savoir plus et g\xE9rer les param\xE8tres ',
  collapsed_subtitle_here: 'ici',
  collapsed_decline: 'Refuser',
  collapsed_accept: 'Accepter',
  expanded_title: 'Cookies Manager',
  expanded_subtitle:
    "Lorsque vous visitez notre site web, nous utilisons des cookies et des technologies similaires pour vous offrir une exp\xE9rience s\xFBre et fiable. Certains cookies sont essentiels au fonctionnement de notre site web et ne n\xE9cessitent pas votre consentement. Par ailleurs, nous utilisons \xE9galement des cookies non essentiels pour adapter nos services et nos activit\xE9s de marketing. Nous demandons votre consentement explicite avant de d\xE9ployer des cookies non essentiels. Nous vous remercions d'avoir choisi de visiter notre site web et de nous confier vos pr\xE9f\xE9rences en mati\xE8re de protection de vos donn\xE9es personnelles.",
  expanded_learn_more: 'En savoir plus sur nos cookies :',
  expanded_learn_more_google:
    'Nous utilisons Google et d\u2019autres services pour le marketing :',
  expanded_cookie_policy: 'Politique de cookies',
  expanded_cookie_policy_google: 'Google Politique de cookies',
  expanded_accept_all: 'Accepter tout',
  expanded_confirm_my_choices: 'Confirmer mon choix',
  expanded_preferences_title: 'Pr\xE9f\xE9rences',
  expanded_always_active: 'Toujours actifs',
  expanded_essential: 'Essentiel',
  expanded_essential_description:
    'Ces cookies sont n\xE9cessaires au fonctionnement du site web. Ils ne peuvent donc pas \xEAtre d\xE9sactiv\xE9s.',
  expanded_analytics: 'Analytics',
  expanded_analytics_description:
    "Les cookies analytiques recueillent des donn\xE9es sur l'utilisation du site web. Ces donn\xE9es nous aident \xE0 am\xE9liorer en permanence le contenu du site web.",
  expanded_marketing: 'Marketing',
  expanded_marketing_description:
    'Les cookies de marketing collectent des informations sur les campagnes publicitaires et leur succ\xE8s. Cela nous aide \xE0 adapter la publicit\xE9 \xE0 vos int\xE9r\xEAts.',
};
var Vt = {
  collapsed_title: 'Siamo autorizzati a utilizzare i cookie?',
  collapsed_subtitle:
    'I cookie ci aiutano a migliorare la vostra esperienza, ad adattare gli annunci ai vostri interessi e a ottimizzare il nostro sito web. Per saperne di pi\xF9 e gestire le impostazioni ',
  collapsed_subtitle_here: 'aui',
  collapsed_decline: 'Scarto',
  collapsed_accept: 'Accettare',
  expanded_title: 'Cookies Manager',
  expanded_subtitle:
    "Quando visitate il nostro sito web, utilizziamo cookie e tecnologie simili per offrirvi un'esperienza sicura e affidabile. Alcuni cookie sono essenziali per la funzionalit\xE0 del nostro sito e non richiedono il vostro consenso. Inoltre, utilizziamo anche cookie non essenziali per personalizzare i nostri servizi e le nostre attivit\xE0 di marketing. Chiediamo il vostro esplicito consenso prima di utilizzare qualsiasi cookie non essenziale. Vi ringraziamo per aver scelto di visitare il nostro sito web e per averci affidato le vostre preferenze in materia di privacy",
  expanded_learn_more: 'Per saperne di pi\xF9 sui nostri cookie:',
  expanded_learn_more_google:
    'Utilizziamo Google e altri servizi per il marketing:',
  expanded_cookie_policy: 'Politica sui cookie',
  expanded_cookie_policy_google: 'Google Politica sui cookie',
  expanded_accept_all: 'Accetta tutto',
  expanded_confirm_my_choices: 'Confermare le mie scelte',
  expanded_preferences_title: 'Preferenze di consenso',
  expanded_always_active: 'Sempre attivo',
  expanded_essential: 'Essential',
  expanded_essential_description:
    'Questi cookie sono necessari per il funzionamento del sito web. Pertanto non possono essere disattivati.',
  expanded_analytics: 'Analytics',
  expanded_analytics_description:
    "I cookie analitici raccolgono dati sull'utilizzo del sito web. Questi dati ci aiutano a migliorare continuamente il contenuto del sito.",
  expanded_marketing: 'Marketing',
  expanded_marketing_description:
    'I cookie di marketing raccolgono informazioni sulle campagne pubblicitarie e sul loro successo. Questo ci aiuta ad adattare la pubblicit\xE0 ai vostri interessi.',
};
var Ht = {
  collapsed_title: 'Estamos autorizados a utilizar cookies?',
  collapsed_subtitle:
    'Os cookies ajudam-nos a melhorar a sua experi\xEAncia, a adaptar os an\xFAncios aos seus interesses e a otimizar o nosso s\xEDtio Web. Saber mais e gerir defini\xE7\xF5es ',
  collapsed_subtitle_here: 'a`qui',
  collapsed_decline: 'Recusar',
  collapsed_accept: 'Aceitar',
  expanded_title: 'Cookies Manager',
  expanded_subtitle:
    'Quando visita o nosso s\xEDtio Web, utilizamos cookies e tecnologias semelhantes para lhe proporcionar uma experi\xEAncia segura e fi\xE1vel. Alguns cookies s\xE3o essenciais para a funcionalidade do nosso s\xEDtio Web e n\xE3o requerem o seu consentimento. Al\xE9m disso, tamb\xE9m utilizamos cookies n\xE3o essenciais para adaptar os nossos servi\xE7os e actividades de marketing. Solicitamos o seu consentimento expl\xEDcito antes de utilizar quaisquer cookies n\xE3o essenciais. Obrigado por visitar o nosso s\xEDtio Web e por nos confiar as suas prefer\xEAncias de privacidade.',
  expanded_learn_more: 'Saiba mais sobre os nossos cookies:',
  expanded_learn_more_google:
    'Utilizamos o Google e outros servi\xE7os para marketing:',
  expanded_cookie_policy: 'Pol\xEDtica de Cookies',
  expanded_cookie_policy_google: 'Google Pol\xEDtica de Cookies',
  expanded_accept_all: 'Aceitar tudo',
  expanded_confirm_my_choices: 'Confirmar as minhas escolhas',
  expanded_preferences_title: 'Consent preferences',
  expanded_always_active: 'Sempre ativo',
  expanded_essential: 'Essencial',
  expanded_essential_description:
    'Estes cookies s\xE3o necess\xE1rios para o funcionamento do s\xEDtio Web. Por conseguinte, n\xE3o podem ser desactivados.',
  expanded_analytics: 'Analytics',
  expanded_analytics_description:
    'Os cookies anal\xEDticos recolhem dados sobre a utiliza\xE7\xE3o do s\xEDtio Web. Estes dados ajudam-nos a melhorar continuamente o conte\xFAdo do s\xEDtio Web.',
  expanded_marketing: 'Marketing',
  expanded_marketing_description:
    'Os cookies de marketing recolhem informa\xE7\xF5es sobre campanhas publicit\xE1rias e o seu sucesso. Isto ajuda-nos a adaptar a publicidade aos interesses do utilizador.',
};
var oe = { en: qt, de: jt, fr: Kt, es: Wt, it: Vt, pt: Ht },
  h = (t, { lng: e }) => {
    var o, r, i;
    return e in oe
      ? (r = (o = oe[e][t]) != null ? o : oe.en[t]) != null
        ? r
        : t
      : (i = oe.en[t]) != null
        ? i
        : t;
  };
import ar from 'react';
import dr from 'classnames';
var Yt = { container: 'cm_Container-module__container_exPuE' };
var De = ({ children: t, className: e }) =>
  ar.createElement('div', { className: dr(Yt.container, e) }, t);
var re = {
  actions: 'cm_Collapsed-module__actions_BVffj',
  title: 'cm_Collapsed-module__title_CJImX',
  description: 'cm_Collapsed-module__description_CEGgZ',
};
var Le = ({ language: t, onAcceptAll: e, onDecline: o, onExpand: r }) =>
  D.createElement(
    De,
    null,
    D.createElement(
      'div',
      null,
      D.createElement(
        Jt.Headline,
        { weight: 'bold', size: 'medium', className: re.title },
        h('collapsed_title', { lng: t }),
      ),
      D.createElement(
        Jt,
        { size: 'medium', className: re.description },
        h('collapsed_subtitle', { lng: t }),
        ' ',
        D.createElement(
          Se,
          { type: 'plaintext', color: 'link', onClick: r },
          h('collapsed_subtitle_here', { lng: t }),
        ),
      ),
    ),
    D.createElement(
      'div',
      { className: re.actions },
      D.createElement(
        Se,
        { onClick: o, size: 'large', type: 'outlined' },
        h('collapsed_decline', { lng: t }),
      ),
      D.createElement(
        Se,
        { size: 'large', onClick: e, iconEnd: D.createElement(be, null) },
        h('collapsed_accept', { lng: t }),
      ),
    ),
  );
import k from 'react';
import {
  Button as ne,
  Divider as Zt,
  Modal as fr,
  Typography as ie,
} from '@getquin/ui-kit';
import I, { useState as lr } from 'react';
import { Toggle as ur, Typography as Ne } from '@getquin/ui-kit';
var z = {
  expand_cta: 'cm_Destination-module__expand_cta_In1hO',
  label: 'cm_Destination-module__label_QaMzi',
  destination: 'cm_Destination-module__destination_mmV82',
  destination_label: 'cm_Destination-module__destination_label_c4qPT',
  destination_description:
    'cm_Destination-module__destination_description_BULl9',
  active_always_dot: 'cm_Destination-module__active_always_dot_r-w3R',
};
var Te = ({
  label: t,
  checked: e,
  description: o,
  disabled: r,
  language: i,
  onChange: n,
}) => {
  let [s, d] = lr(!1),
    l = s ? Ae : Pe;
  return I.createElement(
    'div',
    null,
    I.createElement(
      'div',
      { className: z.destination },
      I.createElement(
        'div',
        { className: z.destination_label },
        I.createElement(
          'div',
          { className: z.expand_cta, onClick: () => d((a) => !a) },
          I.createElement(l, { width: 20, height: 20 }),
        ),
        I.createElement(
          Ne.Headline,
          { size: 'small', className: z.label, component: 'span' },
          t,
        ),
      ),
      !r &&
        I.createElement(ur, {
          checked: e,
          onChange: (a) => (n == null ? void 0 : n(a)),
        }),
      r &&
        I.createElement(
          I.Fragment,
          null,
          I.createElement(
            Ne.Headline,
            { size: 'small', color: 'success' },
            h('expanded_always_active', { lng: i }),
          ),
          I.createElement('div', { className: z.active_always_dot }),
        ),
    ),
    s &&
      I.createElement(
        Ne,
        {
          size: 'medium',
          className: z.destination_description,
          component: 'p',
        },
        o,
      ),
  );
};
var T = {
  actions: 'cm_Expanded-module__actions_KOYyd',
  modal: 'cm_Expanded-module__modal_RaCcS',
  divider_top: 'cm_Expanded-module__divider_top_yn9H8',
  divider_bottom: 'cm_Expanded-module__divider_bottom_Qz5Zh',
  preferences_title: 'cm_Expanded-module__preferences_title_-1aZy',
  learn_more: 'cm_Expanded-module__learn_more_PO-hT',
};
var Re = ({
  language: t,
  preferences: e,
  onSelectionChange: o,
  onCollapse: r,
  onAcceptAll: i,
  onAcceptSelected: n,
}) => {
  let s = () => {
      window.open('https://business.safety.google/privacy/', '_blank');
    },
    d = () => {
      if (t === 'en') {
        window.open('https://www.getquin.com/cookie-table/', '_blank');
        return;
      }
      window.open(`https://www.getquin.com/${t}/cookie-table/`, '_blank');
    };
  return k.createElement(
    fr,
    {
      opened: !0,
      onClose: r,
      title: h('expanded_title', { lng: t }),
      className: T.modal,
    },
    k.createElement(ie, { size: 'medium' }, h('expanded_subtitle', { lng: t })),
    k.createElement(
      ie,
      { className: T.learn_more, component: 'p', size: 'medium' },
      h('expanded_learn_more', { lng: t }),
      ' ',
      k.createElement(
        ne,
        { type: 'plaintext', color: 'link', onClick: d },
        h('expanded_cookie_policy', { lng: t }),
      ),
    ),
    k.createElement(
      ie,
      { className: T.learn_more, component: 'p', size: 'medium' },
      h('expanded_learn_more_google', { lng: t }),
      ' ',
      k.createElement(
        ne,
        { type: 'plaintext', color: 'link', onClick: s },
        h('expanded_cookie_policy_google', { lng: t }),
      ),
    ),
    k.createElement(Zt, { className: T.divider_top, ignorePaperGutters: !0 }),
    k.createElement(
      ie.Headline,
      { className: T.preferences_title, size: 'medium', component: 'span' },
      h('expanded_preferences_title', { lng: t }),
    ),
    At.map(({ category: l, labelKey: a, descriptionKey: u }) => {
      let f = h(a, { lng: t }),
        p = h(u, { lng: t });
      return k.createElement(Te, {
        key: l,
        checked: !!e[l],
        onChange: () => o(E(v({}, e), { [l]: !e[l] })),
        disabled: l === 'functional',
        description: p,
        label: f,
        language: t,
      });
    }),
    k.createElement(Zt, {
      className: T.divider_bottom,
      ignorePaperGutters: !0,
    }),
    k.createElement(
      'div',
      { className: T.actions },
      k.createElement(
        ne,
        { size: 'large', type: 'outlined', onClick: i },
        h('expanded_accept_all', { lng: t }),
      ),
      k.createElement(
        ne,
        { size: 'large', onClick: () => n(e) },
        h('expanded_confirm_my_choices', { lng: t }),
      ),
    ),
  );
};
var Qt = () => typeof window == 'undefined',
  hr = pr(({ forcedOpen: t, writeKey: e, language: o, onCookieAccept: r }) => {
    let i = xr(() => (Qt() ? {} : Ut()), []);
    return (
      mr(() => {
        Oe() && ve();
      }, []),
      Qt()
        ? null
        : H.createElement(
            Pt,
            {
              writeKey: e,
              shouldReload: !1,
              defaultDestinationBehavior: 'imply',
              initialPreferences: i,
              shouldRequireConsent: te,
              mapCustomPreferences: zt,
            },
            ({ saveConsent: n, preferences: s, setPreferences: d }) => {
              if (!t && (!te() || we())) return H.createElement(cr, null);
              let l = (a) => {
                n(a, !1), r == null || r(a), a.marketingAndAnalytics && ve();
              };
              return H.createElement(yr, {
                language: o,
                preferences: s,
                onAcceptAll: () => l(ee),
                onAcceptSelected: l,
                onDecline: () => l(i),
                onSelectionChange: d,
              });
            },
          )
    );
  }),
  yr = (t) => {
    let [e, o] = gr(!1);
    return e
      ? H.createElement(Re, E(v({}, t), { onCollapse: () => o(!1) }))
      : H.createElement(Le, E(v({}, t), { onExpand: () => o(!0) }));
  };
export {
  hr as CookiesConsent,
  G as DestinationCategory,
  Oe as isAnalyticsEnabled,
  Qo as loadAnalytics,
};
/*! Bundled license information:

js-cookie/src/js.cookie.js:
  (*!
   * JavaScript Cookie v2.2.1
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   *)

js-cookie/src/js.cookie.js:
  (*!
   * JavaScript Cookie v2.2.0
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   *)
*/
